import React from 'react'
import { Modal } from 'react-bootstrap'

function AssignConfirmation({isVisible, message, onConfirm, onCancel}) {
  if (!isVisible) return null
  return (
    <Modal
      show={isVisible}
    //   onHide={onHide}
      size='md'
      aria-labelledby='contained-modal-title-vcenter'
      centered
      backdrop='static'
      backdropClassName='custom-backdrop'
      contentClassName='custom-modal-content'
    >
     <div className='alert alert-dismissible bg-white d-flex flex-center flex-column py-10 px-10 px-lg-20 mb-10'>
      <div className='text-center'>

        <div className='mb-9 fs-4 text-dark'>{message}</div>
        <div className='d-flex flex-center flex-wrap'>
          <a
            onClick={onCancel}
            className='btn btn-outline btn-outline-danger btn-active-danger m-2'
          >
            No
          </a>
          <button onClick={onConfirm} className='btn btn-danger m-2'>
            Yes
          </button>
        </div>
      </div>
    </div>
    </Modal>
  )
}

export default AssignConfirmation
